<script lang="ts">
  import { pick } from 'lodash-es'
  import { isNonEmptyPlainObject } from '#app/lib/boolean_tests'
  import { onChange } from '#app/lib/svelte/svelte'
  import { objectKeys } from '#app/lib/utils'
  import { propertiesByRoles } from '#entities/components/lib/claims_helpers'
  import { authorRoleProperties } from '#entities/lib/editor/properties_per_subtype'
  import { getEntitiesAttributesFromClaims, type SerializedEntity } from '#entities/lib/entities'
  import Spinner from '#general/components/spinner.svelte'
  import AuthorsInfoRole from './authors_info_role.svelte'

  const {
    claims = {},
  }: {
    claims: SerializedEntity['claims']
  } = $props()

  let authorsByUris = $state()
  const authorsClaims = $derived(pick(claims, authorRoleProperties))
  const waitingForAuthors = getAuthors()
  async function getAuthors () {
    if (isNonEmptyPlainObject(authorsClaims)) {
      // 'claims' attribute is necessary to get birth and death years
      const attributes = [ 'labels', 'claims', 'image' ] as const
      authorsByUris = await getEntitiesAttributesFromClaims(authorsClaims, attributes)
    }
  }

  $effect(() => {
    onChange(authorsClaims, getAuthors)
  })
</script>

{#await waitingForAuthors}
  <Spinner />
{:then}
  {#if authorsByUris}
    <div class="authors-info">
      {#each objectKeys(propertiesByRoles) as roleLabel (roleLabel)}
        <AuthorsInfoRole
          {roleLabel}
          roleProperties={propertiesByRoles[roleLabel]}
          {claims}
          {authorsByUris}
        />
      {/each}
    </div>
  {/if}
{/await}

<style lang="scss">
  @import "general/scss/utils";
  .authors-info{
    @include display-flex(row, flex-end, flex-start, wrap);
  }
</style>
